import router from '.'
export default [
  router.beforeEach((to, from, next) => {
    // If visiting login view but you already have logged in redirect to home.
    if (to.name === 'Login' && window.localStorage.loggedIn) {
      next({
        name: 'Dashboard'
      })
    }

    if (to.name === 'Reset Password' && window.localStorage.loggedIn) {
      next({
        name: 'Dashboard'
      })
    }

    // Remove session on logout.
    if (to.name === 'Logout') {
      window.localStorage.clear()
      next({
        path: '/login'
      })
    }

    // Redirect to login all request that need authentication if user is not logged.
    if (to.meta.requiresAuth && !window.localStorage.loggedIn) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
    next()
  })
]



// WEBPACK FOOTER //
// ./src/router/routerInterceptor.js